module.exports = __webpack_public_path__ + "img/collection.04f27053.svg";